const lighten = (color: string, amount: number) =>  
  '#' + color
    .replace(/^#/, '')
    .replace(/../g, 
      color => (c => Math.min(255, Math.max(0, Math.round(c*(1 + amount)))).toString(16).padStart(2, "0"))(parseInt(color, 16))
    );

export default lighten;